<template>
    <Transition>
        <div v-show="isVisible" id="cookie-notice" aria-labelledby="cookie-notice-text" aria-modal="false" class="uk-text-small uk-light" role="dialog">
            <div class="uk-padding-small">
                <div class="uk-flex uk-flex-middle uk-flex-left uk-grid uk-grid-small">
                    <div class="uk-width-auto">
                        <span class="uk-text-nowrap" style="text-decoration: underline; cursor: pointer;" @click="hide">
                            <svg class="icon icon-tabler icon-tabler-x" fill="none" height="20" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0h24v24H0z" fill="none" stroke="none" />
                                <line x1="18" x2="6" y1="6" y2="18" />
                                <line x1="6" x2="18" y1="6" y2="18" />
                            </svg>
                        </span>
                    </div>
                    <div class="uk-width-expand">
                        <span id="cookie-notice-text">By using this site, you agree to our <a href="/about/privacy-policy" style="text-decoration: underline;">Privacy Policy</a></span>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import {computed, onMounted} from 'vue'
import {useCookieNoticeStore} from "../../stores/CookieNoticeStore";

const cookieNoticeStore = useCookieNoticeStore()

const isVisible = computed(() => cookieNoticeStore.isVisible)

onMounted(() => {
    setTimeout(function () {
        hide()
    }, 15000);
})

function hide() {
    cookieNoticeStore.hide()
}
</script>

<style scoped>
#cookie-notice {
    background: #343434;
    position: fixed;
    width: 100%;
    bottom: 0;
    color: #fff !important;
    z-index: 99;
}

#cookie-notice a {
    white-space: nowrap;
}

.v-enter-active,
.v-leave-active {
    transition: opacity 0.75s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
